/**
 * Signed-out pages (views/partials/auth-start + auth-end): sign in,
 * password reset, two-step verification.
 *
 *  [data-password-toggle]  show / hide the password in its .auth-password
 *  [data-copy="#el"]       copy that element's value / text (spaces removed)
 *  [data-otp]              6-digit code: digits only, pasted codes cleaned
 *                          up, submits its form once all six are in
 *  [data-match="#input"]   must equal that input (confirm password)
 */
(() => {
  // Show / hide password
  document.querySelectorAll('[data-password-toggle]').forEach((btn) => {
    const input = btn.closest('.auth-password')?.querySelector('input');
    if (!input) return;
    btn.addEventListener('click', () => {
      const show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      btn.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
      btn.querySelector('i').className = show ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye';
      input.focus();
    });
  });

  // Copy the 2FA key
  document.querySelectorAll('[data-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const source = document.querySelector(btn.dataset.copy);
      if (!source) return;
      const value = ('value' in source ? source.value : source.textContent).replace(/\s+/g, '');
      try {
        await navigator.clipboard.writeText(value);
      } catch {
        // Older browsers: copy via a temporary field
        const temp = Object.assign(document.createElement('textarea'), { value });
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        temp.remove();
      }
      window.ui?.toast('Key copied');
    });
  });

  // 6-digit codes
  document.querySelectorAll('[data-otp]').forEach((input) => {
    const form = input.closest('form');
    let submitted = false;
    input.addEventListener('input', () => {
      const digits = input.value.replace(/\D/g, '').slice(0, 6);
      if (input.value !== digits) input.value = digits;
      if (digits.length === 6 && !submitted && form?.checkValidity()) {
        submitted = true;
        form.requestSubmit();
      }
    });
    form?.addEventListener('submit', () => {
      submitted = true;
      form.querySelectorAll('button[type="submit"]').forEach((b) => (b.disabled = true));
    });
  });

  // Confirm password must match
  document.querySelectorAll('[data-match]').forEach((confirm) => {
    const original = document.querySelector(confirm.dataset.match);
    if (!original) return;
    const check = () => confirm.setCustomValidity(confirm.value && confirm.value !== original.value ? "Passwords don't match" : '');
    confirm.addEventListener('input', check);
    original.addEventListener('input', check);
  });
})();
